import React from "react"
import News from "../../blocks/news"
import { graphql } from "gatsby"
import Img from "gatsby-image"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "asani_ska" }) {
    ...NewsInfo
    innerImages {
      signing {
        childImageSharp {
          fluid(maxWidth: 1680) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
}`

export default class NewsText extends News {
  renderNews() {
    const { signing } = this.props.data.news.innerImages
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>23-летний левый защитник Джелил Асани стал клиентом Catenaccio Sports Agency и при участии агентства подписал однолетний контракт с клубом «СКА-Хабаровск», став первым македонцем в истории клуба. До СКА Асани выступал за боснийский «Младост».</p>
          
          <Img fluid={ signing.childImageSharp.fluid } alt="Подписание контракта" width="100%" />

          <div className="video">
            <iframe
              src="https://www.youtube.com/embed/4plpJ1xecu0"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    )
  }
}